define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/html/StateWidget",
	"csi/html",
	"csi/locale",
	"./_SalesCollectionStateMixin"
], function(declare,domClass,query,StateWidget,html,locale,_SalesCollectionStateMixin) {

	return declare([StateWidget,_SalesCollectionStateMixin], {
		_processHtml: function(/*Context*/ctx, /*DOMNode*/dom) {
			// summary: process each element with a key according to its matching definition
			this.inherited(arguments);
			
			const node = ctx.getNode();
			const css = this.getSalesStateCss(ctx);

			const eDraft = query(".draft", dom)[0];
			const eAvailable = query(".available", dom)[0];
			const eSoldOut = query(".soldout", dom)[0];
			const eNotAvailable = query(".notavailable", dom)[0];
			
			switch (node.State) {
				case "SMState:Draft":
					domClass.add(eDraft, css);
					break;
				case "SMState:AvailableToSell":	
					domClass.add(eAvailable, css); 
					break;
				case "SMState:SoldOut":
					domClass.add(eSoldOut, css);
					break;
				case "SMState:NotAvailable":
					domClass.add(eNotAvailable, css);
					break;
			}

			html.text(eDraft, locale.getEnumName("SMState:Draft", true));
			html.text(eAvailable, locale.getEnumName("SMState:AvailableToSell", true));
			html.text(eSoldOut, locale.getEnumName("SMState:SoldOut", true));
			html.text(eNotAvailable, locale.getEnumName("SMState:NotAvailable", true));
		}
	});
});